<template>
    <div class="text-start d-flex justify-content-center">
        <form  class="form w-custom" @submit.prevent="sendEmail">
            <div class="row">
                <div class="form-group col-md-6">
                    <label for="inputFirstName">Ime</label>
                    <input v-model="name" name="name" type="text" class="form-control" id="inpuFirstName" placeholder="Matic">
                </div>
                <div class="form-group col-md-6">
                    <label for="inputLastName">Priimek</label>
                    <input v-model="surname" name="surname" type="text" class="form-control" id="inputLastName" placeholder="Mori">
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <label for="inputOsebe">Število oseb</label>
                    <input v-model="numberOfPeople" name="numberOfPeople" type="text" class="form-control" id="inputOsebe" placeholder="1-50 oseb">
                </div>
                <div class="form-group col-md-6">
                    <label for="inputDatum">Datum</label>
                    <input v-model="date" name="date" type="tel" class="form-control" id="inputDatum" placeholder="01.11.1995">
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <label for="inputPhone">Telefonska številka</label>
                    <input v-model="phoneNumber" name="phoneNumber" type="tel" class="form-control" id="inputPhone" placeholder="041-434-356">
                </div>
                <div class="form-group col-md-6">
                    <label for="inputEmail">E-mail</label>
                    <input v-model="mail" name="mail" type="text" class="form-control" id="inputEmail" placeholder="matic@avtoprevoznistvo-topler.eu">
                </div>
            </div>
            <div class="form-group">
                <label for="inputRelacija">Relacija</label>
                <input v-model="relation" name="relation" type="text" class="form-control" id="inputRelacija" placeholder="Točka A - Točka B">
            </div>
            <div class="form-group">
                <label for="InputZahteve">Vprašanja in zahteve</label>
                <textarea v-model="notes" name="notes" class="form-control" id="InputZahteve" rows="4" placeholder=""></textarea>
            </div>
            <div class="submit mt-3 d-flex justify-content-end">
                <button type="reset" class="btn btn-custom me-3 border">Ponastavi</button>
                <button type="submit" class="btn btn-custom border">Pošlji</button>
            </div>
        </form>
    </div>
</template>

<script>
import emailjs from 'emailjs-com';

export default {
    name: "ContactForm",
    data(){
        return{
            name: '',
            surname: '',
            numberOfPeople: '',
            date: '',
            phoneNumber: '',
            mail: '',
            relation: '',
            notes: ''
        }
    },
    methods:{
        sendEmail(e){
            try {
                console.log(this.name);
                emailjs.sendForm('aptoplerWeb_service', 'aptoplerWeb_template', e.target,
                '6spysw2qG4bd75H7v', {
                name: this.name,
                surname: this.surname,
                numberOfPeople: this.numberOfPeople,
                date: this.date,
                phoneNumber: this.phoneNumber,
                mail: this.mail,
                relation: this.relation,
                notes: this.notes
                })

            } catch(error) {
                console.log({error})
            }

            //Reset form
            this.name = ''
            this.surname = ''
            this.numberOfPeople = ''
            this.date = ''
            this.phoneNumber = ''
            this.mail = ''
            this.relation = ''
            this.notes = ''
        }
    }
};
</script>